"use client";
import { useState, useEffect } from "react";
import { Room, RoomEvent } from "livekit-client";

/**
 * Manages room connection state.
 */
interface UseRoomConnectionOptions {
  room: Room;
}

interface UseRoomConnectionReturn {
  isReconnecting: boolean;
}

/**
 * Manages room connection state.
 */
export const useRoomConnection = ({ room }: UseRoomConnectionOptions): UseRoomConnectionReturn => {
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    const handleReconnecting = () => setIsReconnecting(true);
    const handleReconnected = () => setIsReconnecting(false);

    room.on(RoomEvent.Reconnecting, handleReconnecting);
    room.on(RoomEvent.Reconnected, handleReconnected);
    room.on(RoomEvent.Connected, handleReconnected);

    return () => {
      room.off(RoomEvent.Reconnecting, handleReconnecting);
      room.off(RoomEvent.Reconnected, handleReconnected);
      room.off(RoomEvent.Connected, handleReconnected);
    };
  }, [room]);

  return {
    isReconnecting
  };
};
